import https from "./https";

const organizationVariable = {
  list({page, per_page, org_code, merchant_id, merchant_type, keys, keyword, activated_only, no_merchant}) {
    let params = {page, per_page, merchant_type, merchant_id, activated_only, no_merchant};
    if (keyword !== null && keyword !== undefined && keyword !== "") {
      params = {
        ...params,
        keyword,
      }
    }
    if (keys) {
      params = {
        ...params,
        keys: keys.join(',')
      }
    }
    if (!org_code) {
      return Promise.reject('org_code not found.')
    }

    return https.get(`/admin/organizations/${org_code}/variables`, {params});
  },

  get({org_code, organization_variable_id}) {
    return https.get(`/admin/organizations/${org_code}/variables/${organization_variable_id}`);
  },

  getByKey({org_code, key}) {
    return https.get(`/admin/organizations/${org_code}/variables-by-key/${key}`);
  },

  update({org_code, organizationVariable}) {
    return https.put(`/admin/organizations/${org_code}/variables/${organizationVariable.id}`, organizationVariable);
  },

  updateByKeys(org_code, variables) {
    return https.put(`/admin/organizations/${org_code}/variables-by-keys/`, {variables});
  },

  store({org_code, organizationVariable}) {
    return https.post(`/admin/organizations/${org_code}/variables`, organizationVariable);
  },

  remove({org_code, organizationVariable}) {
    return https.delete(`/admin/organizations/${org_code}/variables/${organizationVariable.id}`);
  },

  activate(orgId, params) {
    if (!orgId) {
      return Promise.reject("orgId not found.");
    }

    return https.post(
      `/admin/organizations/${orgId}/variables/activate`,
      params
    );
  }
};

export default organizationVariable;
